<template>
  <div class="d-block d-lg-flex">
    <div
      class="wishlists-icon-container collection-icon"
      :class="[!inWishlist && 'd-none']"
      @click="onClick"
    >
      <font-awesome-icon
        :icon="['fas', 'trash']"
        class="icon-trash cursor-pointer"
        size="1x"
      />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

export default {
  components: {
    FontAwesomeIcon,
  },

  props: {
    dealId: {
      type: Number,
      required: true,
    },
  },

  computed: {
    requestErrorMessage() {
      return this.$store.getters['wishlists/errorMessage'];
    },

    wishlist() {
      return this.$store.getters['wishlists/wishlist'];
    },

    wishlists() {
      return this.$store.getters['wishlists/wishlists'];
    },

    canChange() {
      // only for collections, do we care if user is owner
      return this.wishlist?.is_owner;
    },

    wishlistDeal() {
      return this.wishlist && this.wishlist.deals.find(
        (deal) => deal.id === this.dealId,
      );
    },

    inWishlist() {
      return this.wishlist && !!this.wishlist.deals.find(
        (deal) => deal.id === this.dealId,
      );
    },
  },

  methods: {
    async onClick(event) {
      if (!this.canChange) {
        // do nothing if we can't edit
        return;
      }

      this.$emit('click', event);

      if (this.inWishlist) {
        await this.removeFromList();
      }
    },

    async removeFromList() {
      if (this.isProcessing) {
        return;
      }

      await this.$store.dispatch('wishlists/removeFromList', { wishlistDealId: this.wishlistDeal.wishlist_deal_id });

      if (this.requestErrorMessage) {
        this.$toastr.e(this.requestErrorMessage);
        return;
      }

      this.$toastr.s(`Removed from <strong>${this.wishlist.name}</strong> wishlist!`);

      this.$store.dispatch('wishlists/getWishlistsHeaderData', this.wishlist.slug);
    },
  },
};
</script>

<style lang="scss">
@import '~/styles/dorado/themes/dorado';
@import '~/styles/utils/breakpoints';

.collection-icon {
  background-color: #fff;
  border-radius: 50%;
  border: 1px solid $gray-300;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  height: 30px;
  padding: 6px 9px;
  position: relative;
  margin: auto 0;
  width: 30px;
  z-index: 3;
}

.icon-trash path {
  fill: $brick;
}

@include media-breakpoint-up(md) {
  .collection-icon {
    height: 40px;
    width: 40px;
    padding: 8px 12px;
  }
}
</style>
